import styled from "styled-components";

import { EmptyState } from "@similarweb/ui-components";

export const StyledSearchErrorState = styled(EmptyState)`
    min-height: 250px;
    text-align: center;
`;
